export default "/assets/images/the-overreactor-crop.webp?ef306c8412b2b4f324ec303253a52b07";